import { combineReducers } from "redux";

// Import reducers as they are created
// import mediaReducer from "./mediaReducer";
import startupReducer from "./startupReducer";
import libraryCardReducer from "./libraryCardReducer";
import videoSubmissionReducer from "./videoSubmissionReducer";
import contentComposerReducer from "./contentComposerReducer";
import videoRenderReducer from "./videoRenderReducer";
import publicationScheduleReducer from "./publicationScheduleReducer";
import contentFeedReducer from "./contentFeedReducer";
import documentSubmissionReducer from "./documentSubmissionReducer";
import reporterAgentReducer from "./reporterAgentReducer";
import contentBacklogReducer from "./contentBacklogReducer";
import researchDeckReducer from "./researchDeckReducer";
import diagramsAgentReducer from "./diagramsAgentReducer";

const rootReducer = combineReducers({
  // media: mediaReducer,
  startup: startupReducer,
  libraryCards: libraryCardReducer,
  videoSubmission: videoSubmissionReducer,
  contentComposer: contentComposerReducer,
  videoRender: videoRenderReducer,
  publicationSchedule: publicationScheduleReducer,
  contentFeed: contentFeedReducer,
  documentSubmission: documentSubmissionReducer,
  reporterAgent: reporterAgentReducer,
  contentBacklog: contentBacklogReducer,
  researchDeck: researchDeckReducer,
  diagramsAgent: diagramsAgentReducer,
  // Add more reducers as needed
});

export default rootReducer;
